/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Ats_FormattingInputs */

const en_onboarding_ats_formatting = /** @type {(inputs: Onboarding_Ats_FormattingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatting`)
};

const de_onboarding_ats_formatting = /** @type {(inputs: Onboarding_Ats_FormattingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatierung`)
};

const fr_onboarding_ats_formatting = /** @type {(inputs: Onboarding_Ats_FormattingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mise en forme`)
};

const es_onboarding_ats_formatting = /** @type {(inputs: Onboarding_Ats_FormattingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato`)
};

const it_onboarding_ats_formatting = /** @type {(inputs: Onboarding_Ats_FormattingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formattazione`)
};

const nl_onboarding_ats_formatting = /** @type {(inputs: Onboarding_Ats_FormattingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opmaak`)
};

const pl_onboarding_ats_formatting = /** @type {(inputs: Onboarding_Ats_FormattingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatowanie`)
};

const fi_onboarding_ats_formatting = /** @type {(inputs: Onboarding_Ats_FormattingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muotoilu`)
};

const da_onboarding_ats_formatting = /** @type {(inputs: Onboarding_Ats_FormattingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatering`)
};

const sv_onboarding_ats_formatting = /** @type {(inputs: Onboarding_Ats_FormattingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatering`)
};

/**
* | output |
* | --- |
* | "Formatting" |
*
* @param {Onboarding_Ats_FormattingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_ats_formatting = /** @type {((inputs?: Onboarding_Ats_FormattingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Ats_FormattingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_ats_formatting(inputs)
	if (locale === "fr") return fr_onboarding_ats_formatting(inputs)
	if (locale === "es") return es_onboarding_ats_formatting(inputs)
	if (locale === "it") return it_onboarding_ats_formatting(inputs)
	if (locale === "nl") return nl_onboarding_ats_formatting(inputs)
	if (locale === "pl") return pl_onboarding_ats_formatting(inputs)
	if (locale === "fi") return fi_onboarding_ats_formatting(inputs)
	if (locale === "da") return da_onboarding_ats_formatting(inputs)
	if (locale === "sv") return sv_onboarding_ats_formatting(inputs)
	return en_onboarding_ats_formatting(inputs)
});